/**
 * pillDnd.ts — the drag-and-drop ids of Admin > Stage Pipeline.
 *
 * Two DndContexts: the stage list (a vertical sortable of the stages after
 * Inquiry, by custom stage id) and the pills (a pill drags onto "…" or the
 * Hidden Stages panel to hide it for the selected stage, and back onto the
 * pipeline row to show it again — FTP's admin-stage-save-hidden.php drop).
 */
import { pointerWithin, rectIntersection, type CollisionDetection } from '@dnd-kit/core';

/** The stage list's DndContext. */
export const STAGE_LIST_DND_ID = 'stage-pipeline-stages';
/** The pills' DndContext (pipeline row, "…" button and Hidden Stages panel). */
export const PILLS_DND_ID = 'stage-pipeline-pills';

/** Where a pill can be dropped. */
export const PILL_DROP = {
  /** The "…" button at the end of the pipeline row: hide. */
  hide: 'pill-drop:hide',
  /** The Hidden Stages panel: hide. */
  hidden: 'pill-drop:hidden',
  /** The pipeline row: show. */
  row: 'pill-drop:row',
} as const;

/**
 * A pill lands where the pointer is (the small "…" button beats the wide row
 * it sits beside); a keyboard drag has no pointer, so it falls back to the
 * target the dragged pill overlaps most.
 */
export const pillCollision: CollisionDetection = (args) => {
  const underPointer = pointerWithin(args);
  return underPointer.length > 0 ? underPointer : rectIntersection(args);
};

const PILL_PREFIX = 'pill:';

export function pillDragId(stageId: number): string {
  return `${PILL_PREFIX}${stageId}`;
}

/** The stage id a pill drag carries, or null for anything else. */
export function stageIdFromPillDrag(id: string | number): number | null {
  const s = String(id);
  if (!s.startsWith(PILL_PREFIX)) return null;
  const n = Number(s.slice(PILL_PREFIX.length));
  return Number.isInteger(n) && n > 0 ? n : null;
}
